import FieldDefs from './SimilarKeysFieldDefs'
import {doLangFields, isGoogleGny} from '../../lib/ks-tools'
import SimilarKeysGny from "./SimilarKeysGny";

export default {
    template: `<div><slot v-bind="self"/></div>`,
    data() {
        return {
            fields: doLangFields(this, "lang.report.similarkeys", isGoogleGny() ? SimilarKeysGny : FieldDefs),
            sortOrder: [
                {
                    field: 'cnt',
                    direction: 'desc'
                }
            ],
            moreParams: {}
        }
    },
    computed: {
        self() {
            return this;
        },
    },
}
